// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.file-input_container_p1oUv {
  display: block;
  position: relative;
  padding: 1rem;
  margin: 1rem 0;
  text-align: center;
  border: 4px dashed var(--ui-tertiary);
  border-radius: 5px;
  cursor: pointer;
  background: none;
  width: 100%;
}

.file-input_container_p1oUv:focus-within {
  border-color: var(--looks-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-custom-extension-modal/file-input.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n  display: block;\n  position: relative;\n  padding: 1rem;\n  margin: 1rem 0;\n  text-align: center;\n  border: 4px dashed var(--ui-tertiary);\n  border-radius: 5px;\n  cursor: pointer;\n  background: none;\n  width: 100%;\n}\n\n.container:focus-within {\n  border-color: var(--looks-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `file-input_container_p1oUv`
};
export default ___CSS_LOADER_EXPORT___;
